import { searchAndMarkSubsidiaryElements } from './subsidiaryOverview';

$('.filial-link').on('click', function (e) {
  e.stopPropagation();
  e.preventDefault();

  const subsidiaryName = $(this)[0].name;

  const searchfield = $('.js-subsidiary-searchfield');
  searchfield.val(subsidiaryName);

  searchAndMarkSubsidiaryElements(subsidiaryName, true);
});
